import React, { useEffect, useState } from "react";
import {   auth,signInWithGoogle,
    logout,} from '../../backend/firebase';

export default function GoogleLogin({user}) {
    return(
        <div>
            <button onClick={signInWithGoogle} className="rounded-lg px-3 py-1 text-gray-600 text-lg border font-medium bg-white bg-no-repeat">Login</button>
        </div>
        
        
    );
}